/*
 * @Author: wangshengqiang
 * @Date: 2021-04-28 15:07:51
 * @LastEditTime: 2022-01-13 14:18:24
 * @LastEditors: wangshengqiang
 * @Description: 保费显示组件
 */
import React, { useEffect, useState, useRef } from 'react';
import { Popup, Icon } from 'zarm';
import classnames from 'classnames';
import { dispatch, useStore, getFormValue, getState } from '@/store';
import { isPreviewMode } from '@/utils/tool';
import Iconfont from '../InsuredWithPlanSelectModule/components/Iconfont';
import { getHashParam } from '@/utils/tool.js';
import { findModuleFromCurrPage } from '@/utils/utils';
import './index.less';

const Sp = props => {
  return /*#__PURE__*/React.createElement("span", {
    className: "sp"
  }, props.children);
};

const Premium = /*#__PURE__*/React.forwardRef((props = {}, ref) => {
  const {
    attrs
  } = props;
  const {
    defaultType = 'year',
    dataSource = []
  } = attrs;
  const {
    name: goodsName
  } = getState('goodsDetail') || {};
  const [detailVisible, setDetailVisible] = useState(false);
  const premium = useStore('premium');
  const planId = useStore('PLAN_ID');
  const isPreview = isPreviewMode();
  const insuredList = getFormValue('insured'); // 被保人是否有保障计划

  const hasInsured = Array.isArray(insuredList) && insuredList.length > 0;
  const hasPlanIdInsuredWithPlanSelect = findModuleFromCurrPage('InsuredWithPlanSelectModule');
  const isPremiumDetailView = !isPreview && hasInsured && hasPlanIdInsuredWithPlanSelect;
  useEffect(() => {
    const hashPage = getHashParam().page || 1;
    if ((premium === null || premium === void 0 ? void 0 : premium.initialPremium) !== undefined && hashPage > 1) return;
    const curr = dataSource.find((item = {}) => item.type === defaultType) || {};
    dispatch('premium', curr);
  }, [defaultType, planId]);
  const cls = classnames({
    'components-premium-render': true // [className]: !!className,

  });

  const changeStatus = () => {
    setDetailVisible(!detailVisible);
  };

  const renderContent = () => {
    // if (!premium) return null;
    const type = premium === null || premium === void 0 ? void 0 : premium.type;

    if (type === 'year') {
      const {
        value = 0,
        remark = '元'
      } = premium;
      const price = value;
      return /*#__PURE__*/React.createElement("div", {
        className: "premium-wrapper"
      }, /*#__PURE__*/React.createElement("div", {
        className: "premium-text large bold"
      }, "\xA5\xA0", price, " ", /*#__PURE__*/React.createElement(Sp, null, premium !== null && premium !== void 0 && premium.initialPremium ? '元' : remark)));
    }

    if (type === 'month') {
      const {
        value = [],
        shit,
        remark = []
      } = premium;
      const [first = 0, rest = 0] = value;
      const firstPrice = first;
      const restPrice = rest;
      return /*#__PURE__*/React.createElement("div", {
        className: "premium-wrapper"
      }, /*#__PURE__*/React.createElement("div", {
        className: "premium-text bold"
      }, "\u9996\u6708\xA0\xA5\xA0", firstPrice, /*#__PURE__*/React.createElement(Sp, null, shit ? '元' : remark[0])), /*#__PURE__*/React.createElement("div", {
        className: "premium-text small"
      }, "\u6B21\u6708\u8D77\xA0\xA5\xA0", restPrice, " ", /*#__PURE__*/React.createElement(Sp, null, shit ? '元' : remark[1], "/\u6708")));
    }

    return '保费试算中';
  };

  const renderInsuredPremium = () => {
    if (hasInsured) {
      return insuredList.map((item = {}) => {
        return /*#__PURE__*/React.createElement("div", {
          className: "insure-premium-item"
        }, /*#__PURE__*/React.createElement("span", null, item.name), /*#__PURE__*/React.createElement("span", {
          className: "premium"
        }, /*#__PURE__*/React.createElement("span", {
          className: "flag"
        }, "\xA5"), Number.isNaN(Number(item.premium)) ? '' : Number(item.premium).toFixed(2)));
      });
    }
  };

  return /*#__PURE__*/React.createElement("div", {
    className: cls,
    ref: ref
  }, /*#__PURE__*/React.createElement("div", null, renderContent()), isPremiumDetailView && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: "change-btn",
    onClick: changeStatus
  }, /*#__PURE__*/React.createElement(Iconfont, {
    className: classnames({
      icon: true,
      'arrow-up': detailVisible
    }),
    type: "right"
  })), /*#__PURE__*/React.createElement(Popup, {
    className: "components-premium-popup-wrapper",
    visible: detailVisible,
    direction: "bottom",
    onMaskClick: changeStatus
  }, /*#__PURE__*/React.createElement("div", {
    className: "popup-box"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "title pop-box-title"
  }, goodsName, /*#__PURE__*/React.createElement("div", {
    className: "module-close",
    onClick: changeStatus
  }, /*#__PURE__*/React.createElement(Icon, {
    className: "icon",
    type: "wrong"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "content"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "title"
  }, "\u88AB\u4FDD\u9669\u4EBA\u53CA\u4EF7\u683C\u660E\u7EC6"), renderInsuredPremium())))));
});
export default Premium;